import React from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import { MenuOutlined, MessageOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems'; // Fixed path
import '../assets/styles/Header.css';

const { Header: AntHeader } = Layout;

const Header = ({ userRole, onLogout, drawerVisible, setDrawerVisible, setChatVisible }) => {
  const showDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);
  const showChat = () => setChatVisible(true);
  const handleLogoutClick = () => {
    onLogout();
  };

  return (
    <AntHeader className="header">
      <div className="logo">
        <Link to="/">
          <img src="/images/logo.png" alt="JectHub Logo" className="logo-image" />
        </Link>
      </div>
      <Button
        className="mobile-menu-button"
        type="primary"
        onClick={showDrawer}
        icon={<MenuOutlined />}
      />
      <Menu theme="light" mode="horizontal" className="menu" style={{ backgroundColor: '#74797c' }}>
        <MenuItems closeDrawer={closeDrawer} />
      </Menu>
      <Drawer title="Menu" placement="right" closable onClose={closeDrawer} open={drawerVisible}>
        <Menu mode="vertical" style={{ backgroundColor: '#50b0e0' }} onClick={closeDrawer}>
          <MenuItems closeDrawer={closeDrawer} />
          {userRole && (
            <Menu.Item key="logout" onClick={handleLogoutClick}>
              Logout
            </Menu.Item>
          )}
        </Menu>
      </Drawer>
      <Button
        className="chat-support-button"
        type="primary"
        shape="circle"
        icon={<MessageOutlined />}
        size="large"
        onClick={showChat}
        style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}
      />
    </AntHeader>
  );
};

export default Header;